<template>
    <div>
        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6">Datos Bancarios<span class="text-subtitle2 text-grey"> </span>
                </div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm" @click="guardarDatos()" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.banco" label="Nombre del Banco" />
                    </div>
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.numeroCuenta" label="Número de Cuenta" />
                    </div>
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.clabe" label="CLABE Interbancaria" />
                    </div>
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.nombreTitular" label="Nombre del Beneficiario" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>


<script>
import axios from 'axios'
import { QSpinnerClock } from 'quasar'

export default {
    name: 'CuentasBancarias',
    data() {
        return {
            form: {
                banco: '',
                numeroCuenta: '',
                clabe: '',
                nombreTitular: ''
            }
        }
    },
    mounted() {
        this.obtenerDatos()
    },
    methods: {

        async guardarDatos() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })
            try {
                await axios.put('Configuracion/UpdateDatosBancarios/' + this.form._id, this.form)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Datos guardados correctamente' })
            } catch (err) {

                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al guardar datos' })
            }
        },

        async obtenerDatos() {
            try {
                const res = await axios.get('Configuracion/GetEmpresa')
                this.form = res.data
            } catch (err) {
                console.error(err)
            }
        }
    }
}
</script>